import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { IoIosOptions } from 'react-icons/io';
import { BsSearch } from 'react-icons/bs';
import { TiArrowSortedDown } from 'react-icons/ti';

import AsyncButton from 'modules/common/components/AsyncButton';

function StatusFilter({
  value,
  options,
  onChange,
  inputClassName,
  containerClassName,
  dropdownContainerClassName,
  optionsPayloadName,
  ...otherProps
}) {
  const [isShown, setShown] = useState(false);
  const [selected, setSelected] = useState();
  const handleChangeSearch = (e) =>
    onChange((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  const handleApplyFilter = () => {
    onChange((prev) => ({
      ...prev,
      is_active: selected,
    }));
    setShown(false);
  };

  return (
    <div
      className={cn(
        'relative flex items-center gap-1 border border-gray-200 rounded-sm',
        containerClassName,
      )}
    >
      {isShown ? (
        <div className="flex flex-grow px-3 items-center justify-between h-[40px]">
          <div className="flex items-center gap-1">
            <IoIosOptions className="rotate-90" />{' '}
            <span className="text-xs ">Filter</span>
          </div>
          <button type="button" onClick={() => setShown(false)}>
            <TiArrowSortedDown className="text-lg" />
          </button>
          <div
            className={cn(
              'absolute -bottom-[11.1rem] rounded drop-shadow-lg z-10 left-0 w-full bg-white py-4 px-3',
              dropdownContainerClassName,
            )}
          >
            <div className="flex justify-between text-xs">
              <h5 className="text-gray-700 font-semibold mb-2">
                Filter By Status
              </h5>
              <button
                type="button"
                onClick={() => setSelected()}
                className="text-primary border-b border-transparent hover:border-primary transition"
              >
                Clear Filter
              </button>
            </div>
            <div className="flex flex-col gap-2 pb-8">
              {options?.map(({ status, label }) => (
                <label
                  key={status}
                  htmlFor={label}
                  className="flex gap-1 items-center cursor-pointer"
                >
                  <input
                    className="cursor-pointer text-primary rounded-full"
                    name="option"
                    type="radio"
                    onChange={() => setSelected(status)}
                    checked={status === selected}
                    id={label}
                  />
                  <span className="capitalize text-xs">{label}</span>
                </label>
              ))}
            </div>
            <div className="flex justify-between pt-3 border-t border-gray-200 ">
              <AsyncButton
                className="text-xs !capitalize !text-gray-500"
                color="regular"
                onClick={() => setShown(false)}
              >
                cancel
              </AsyncButton>
              <AsyncButton
                onClick={handleApplyFilter}
                color="regular"
                className="text-xs !capitalize"
              >
                apply filter
              </AsyncButton>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center h-full pl-3 pr-1 ">
            <BsSearch />
          </div>
          <input
            className={cn(
              'h-[40px] w-[260px] text-gray-500 focus:ring-transparent focus:border-gray-200 border-gray-200 border-0 bg-transparent font-[500] text-[0.7rem]',
              inputClassName,
            )}
            placeholder="Search"
            type="text"
            onChange={handleChangeSearch}
            value={value}
            autoComplete="off"
            {...otherProps}
          />
          <button
            onClick={() => setShown(true)}
            type="button"
            className="border-l border-gray-200 px-3 h-full"
          >
            <IoIosOptions className="rotate-90" />
          </button>
        </>
      )}
    </div>
  );
}

StatusFilter.defaultProps = {
  containerClassName: '',
  dropdownContainerClassName: '',
  inputClassName: '',
  optionsPayloadName: 'is_active',
  options: [
    { status: 1, label: 'active' },
    { status: 0, label: 'inactive' },
  ],
};

StatusFilter.propTypes = {
  containerClassName: PropTypes.string,
  dropdownContainerClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.instanceOf(Array),
  value: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
  optionsPayloadName: PropTypes.string,
};

export default StatusFilter;
